import imageReducer from './reducers';

export default imageReducer;
